// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"142":"3f93d4b5","145":"4fb91c76","176":"670b1747","229":"f0dd2407","758":"0a4200d3","761":"9436d7fc","795":"670b1747","863":"a3fdd16d","958":"01070f50"}[chunkId] + ".chunk.css";
};